import { useRef } from 'react';
import { FILTERED_POSTS_LIMIT } from './config';
import { useFetchWhenInView } from '../../react-hooks/useFetchWhenInView';
import { Loader } from '../Loader';
import { splitIntoBlocks } from '../../lib/splitIntoBlocks';
import { MediaPostListItem } from '../../types';
import { useMasonryGroupResize } from '../../react-hooks/useMasonryGroupResize';
import { MAX_ARTICLE_SIZE, Masonry } from './Masonry';
import { tw } from '../../styles/tw';

interface ContentProps {
  posts: MediaPostListItem[];
  maxColumns?: 3 | 4;
  hasNextPage: boolean;
  onFetchMore(): void;
}

const LoadableMasonry = ({ posts, hasNextPage, onFetchMore, maxColumns }: ContentProps) => {
  const { intersectionObserverRef } = useFetchWhenInView(onFetchMore);
  const blocks = splitIntoBlocks(posts, FILTERED_POSTS_LIMIT);

  const rootRef = useRef<HTMLDivElement>(null);

  useMasonryGroupResize(rootRef, MAX_ARTICLE_SIZE);

  return (
    <div className={tw('h-full border-blood', maxColumns === 3 && 'lg:border-l lg:pl-6')} ref={rootRef}>
      {blocks.map((block) => (
        <Masonry
          className="-mt-6"
          key={block.reduce((combinedId, nextArticle) => combinedId + nextArticle.id, '')}
          articles={block}
          maxColumns={maxColumns}
        />
      ))}
      {hasNextPage && (
        <Loader className="mx-auto my-5 flex justify-center overflow-hidden" ref={intersectionObserverRef} />
      )}
    </div>
  );
};

export { LoadableMasonry };
